import { useState, useEffect, useMemo, useContext } from 'react'
import { toJS } from 'mobx'
import { ListPropsContext, ListTableContext, } from 'src/components'
import { appStore, listStore } from 'src/stores'
import { $api } from 'src/plugins'
import { getHMIBase } from 'src/utils/axios'
import { uuid } from 'src/utils/tools'

const PrintTemplate = (props: { code: string }) => {
  const listProps = useContext(ListPropsContext)
  /**
   * 如果是直接从 ListTable 打开的编辑表单，则 ListTableContext 能拿到，这是大多数的情况
   * 如果从 ListPage 列表表单表格头部按钮打开的编辑表单，则 ListTableContext 不能直接拿到，需要通过 listStore 来拿
   */
  const table = useContext(ListTableContext) || listStore.table.get(listProps.formCode)

  const [iframeId] = useState(uuid())

  const [template, setTemplate] = useState()
  useEffect(() => {
    const { OrgId } = appStore.current.headers
    $api['app/getDataByPost'](
      { keyword: props.code, OrgId },
      { url: 'BD/BDWordTemplate/GetTemplate' }
    ).then((res: any) => {
      res && setTemplate(res)
    })
  }, [props.code])

  const postMsg = (type: string) => {
    const iframe: any = document.getElementById(iframeId)
    iframe?.contentWindow.postMessage({ type, data: toJS(appStore.current.headers) }, '*')
  }

  const url = useMemo(() => {
    if (!template) return

    const { OrgId, Tenant } = appStore.current.headers
    const { ID, DATA_API } = template
    return `${getHMIBase()}/a4-preview?code=${ID}&recordId=${table?.selectedRow.ID}&dataApi=${DATA_API}&sysCode=optiWord&tenant=${Tenant}&orgId=${OrgId}`
  }, [template])

  if (!url) return null

  return (
    <div className='full-parent'>
      <iframe
        id={iframeId}
        onLoad={() => postMsg('event_set_request_header')}
        style={{ width: '100%', height: '100%', border: 'none' }}
        title='word'
        src={url}
      />
    </div>
  )
}

export default PrintTemplate